var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel wraper panel-gray centered" },
    [
      _c("div", { staticClass: "panel-header" }, [
        _c("div", { staticClass: "panel-title" }, [_vm._v(_vm._s(_vm.email))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c("p", { staticClass: "note" }, [_vm._v(_vm._s(_vm.roles))]),
          _vm._v(" "),
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.tempProfile.screenname.$error,
                "error-label": _vm._f("errorLabel")(
                  _vm.$v.tempProfile.screenname
                )
              }
            },
            [
              _c("q-input", {
                attrs: { "float-label": "Имя пользователя", autofocus: true },
                model: {
                  value: _vm.tempProfile.screenname,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempProfile,
                      "screenname",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempProfile.screenname"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("q-input", {
            staticStyle: { position: "absolute", "z-index": "-1" },
            attrs: { readonly: "" },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          }),
          _vm._v(" "),
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.tempProfile.password.$error,
                "error-label": _vm._f("errorLabel")(_vm.$v.tempProfile.password)
              }
            },
            [
              _c("q-input", {
                attrs: { "float-label": "Новый пароль", type: "password" },
                model: {
                  value: _vm.tempProfile.password,
                  callback: function($$v) {
                    _vm.$set(_vm.tempProfile, "password", $$v)
                  },
                  expression: "tempProfile.password"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.retype.$error,
                "error-label": _vm._f("errorLabel")(_vm.$v.retype)
              }
            },
            [
              _c("q-input", {
                attrs: { "float-label": "Повтор пароля", type: "password" },
                model: {
                  value: _vm.retype,
                  callback: function($$v) {
                    _vm.retype = $$v
                  },
                  expression: "retype"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.notReader
            ? _c(
                "q-card",
                [
                  _c(
                    "q-card-main",
                    [
                      _vm.telcode
                        ? [
                            _c("p", [
                              _c("strong", [_vm._v("Telegram")]),
                              _vm._v(
                                " не подключен. Для подключения отправьте "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://tele.click/MTLinkBot",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          MTLink Telegram Bot\n        "
                                  )
                                ]
                              ),
                              _vm._v(" сообщение с текстом:\n        ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              [
                                _c("strong", [
                                  _vm._v("user_" + _vm._s(_vm.telcode))
                                ]),
                                _vm._v(" "),
                                _c("q-btn", {
                                  attrs: {
                                    small: "",
                                    color: "secondary",
                                    icon: "fa-clipboard",
                                    label: "Копировать"
                                  },
                                  on: { click: _vm.copy }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n          После подключения изменения вступят в силу через несколько минут.\n        "
                              )
                            ])
                          ]
                        : _c(
                            "label",
                            [
                              _c("strong", [_vm._v("Telegram")]),
                              _c("span", [_vm._v(" подключен")]),
                              _vm._v(" "),
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    small: "",
                                    outline: "",
                                    color: "warning"
                                  },
                                  on: { click: _vm.telegramOff }
                                },
                                [_vm._v("Отключить")]
                              )
                            ],
                            1
                          )
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("save-btn", {
        attrs: {
          notChanged: _vm.notChanged,
          goView: _vm.goRoot,
          doSave: _vm.doSave
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02bedd0a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02bedd0a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile.vue
// module id = null
// module chunks = 